import {FrontendRequest} from "services-comun/modules/net/request-frontend";
import {logRejection} from "services-comun/modules/decorators/metodo";
import dominio from "../../../portal/ed";
import {IUsuario} from "../interface";

export class WebAuthWebFrontendRequest extends FrontendRequest {
    /* STATIC */
    private static SERVICIO: string = dominio.get(dominio.SERVICES);

    @logRejection(true)
    public static async login(auth: string): Promise<IUsuario> {
        return await this.get<IUsuario>(`${this.SERVICIO}/web/login/`, {
            auth,
        }).then(resp => resp.data);
    }

    @logRejection(true)
    public static async editarUsuario(auth: string, usuario: IUsuario): Promise<void> {
        await this.postJSON<IUsuario, IUsuario>(`${this.SERVICIO}/web/usuario/editar/`, usuario, {
            auth,
        });
    }

    @logRejection(true)
    public static async bajaUsuario(auth: string, email: string): Promise<void> {
        await this.get<IUsuario>(`${this.SERVICIO}/web/usuario/baja/?email=${email}`, {
            auth,
        });
    }

    /* INSTANCE */
}
